export default __webpack_public_path__ + "static/media/Poppins-Bold.404e299b.ttf";